import env from '@/config/env';

/** Matches `resolveBrandingAssetUrl` on the API, which builds these paths. */
const BRANDING_ROUTE = '/core/api/v1/public/branding/';

/**
 * The API returns its assets as app-relative paths, which a browser resolves
 * against the SPA origin. That only works where the same host proxies `/core`,
 * as the Vite dev server does — where the API has its own hostname the path
 * must be rebased onto it. Anything already fetchable passes through.
 */
export function resolveBrandingUrl(value: string): string {
  if (!value.startsWith(BRANDING_ROUTE) || env.API_BASE_URL.startsWith('/')) {
    return value;
  }
  return new URL(value, env.API_BASE_URL).toString();
}

export function resolveBrandingValues<T extends object>(
  branding: T,
): T {
  const entries = Object.entries(branding) as [string, unknown][];
  const resolved: Record<string, unknown> = {};

  for (const [key, value] of entries) {
    if (typeof value === 'string') {
      resolved[key] = resolveBrandingUrl(value);
    } else if (Array.isArray(value)) {
      resolved[key] = (value as unknown[]).map((entry) =>
        typeof entry === 'string' ? resolveBrandingUrl(entry) : entry,
      );
    } else {
      resolved[key] = value;
    }
  }

  return resolved as T;
}
